module.exports = __webpack_public_path__ + "img/RedMissile-B02-4-250.fd4ac959.jpg";